import React from 'react'

import * as S from './styled'

export function TextContainer({
  title,
  titleElement,
  maxWidth,
  textAlign,
  children
}) {
  return (
    <S.TextContainerWrapper style={{ maxWidth, textAlign }}>
      {title && <S.Title as={titleElement}>{title}</S.Title>}
      {children}
    </S.TextContainerWrapper>
  )
}
